import form from "../Form.module.css";
import { ControlledClickPopover } from "components/ClickPopover";
import * as Menu from "components/MenuPanel/MenuPanel";
import { TabList } from "components/Tabs/TabList";
import { Tab } from "components/Tabs/Tab";
import { IconChevronUp } from "components/Icons/IconChevronUp";
import { IconChevronDown } from "components/Icons/IconChevronDown";

import { useState } from "react";

import {
  toRateOption,
  applyRateOptionToCronString,
  rateTabs,
  RateTab,
  getRateOptions,
  RateOption,
} from "../cron/optionsRate";

import type { FormState } from "../FormState";
import type { Dispatch, SetStateAction } from "react";

interface Props<FState> {
  state: FState;
  setState: Dispatch<SetStateAction<FState>>;
}

export function FieldRate<FState extends FormState>(props: Props<FState>) {
  const { state, setState } = props;

  const selectedOption = toRateOption(state.cronString);

  function setSelectedOption(option: RateOption) {
    setState((state) => ({
      ...state,
      cronString: applyRateOptionToCronString(state.cronString, option),
    }));
  }

  const [isOpen, setIsOpen] = useState(false);

  return (
    <label className={form.label}>
      <span>Every</span>

      <ControlledClickPopover
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        // TODO: position="below-full-width"
        position="below-align-left"
        content={({ close }) => (
          <MenuRate
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            close={close}
          />
        )}
      >
        <button type="button">
          <span className={form.fieldText}>{selectedOption ?? "Unset"}</span>
          {!isOpen ? <IconChevronDown /> : <IconChevronUp />}
        </button>
      </ControlledClickPopover>
    </label>
  );
}

function MenuRate({
  selectedOption,
  setSelectedOption,
  close,
}: {
  selectedOption: RateOption | undefined;
  setSelectedOption: (option: RateOption) => void;
  close: () => void;
}) {
  const tabContainingOption =
    rateTabs.find(
      // It's ok if `getRateOptions(tab)` doesn't include selectedOption,
      // that's what we're trying to check
      // @ts-ignore
      (tab) => getRateOptions(tab).includes(selectedOption)
    ) ?? rateTabs[0];

  const [selectedTab, setSelectedTab] = useState<RateTab>(
    tabContainingOption ?? "Minute"
  );

  const options = getRateOptions(selectedTab);

  return (
    <Menu.Panel>
      <Menu.Section
        wrapTitle={false}
        title={
          <TabList size="M">
            {rateTabs.map((tab) => (
              <Tab
                key={tab}
                active={tab === selectedTab}
                onClick={() => {
                  setSelectedTab(tab);

                  const options = getRateOptions(tab);
                  if (options.length === 1) {
                    setSelectedOption(options[0]);
                    close();
                  }
                }}
              >
                {tab}
              </Tab>
            ))}
          </TabList>
        }
      >
        {options.length !== 1 &&
          options.map((option) => (
            <Menu.ItemButton
              key={option}
              selected={option === selectedOption}
              onClick={() => {
                setSelectedOption(option);
                close();
              }}
            >
              {option}
            </Menu.ItemButton>
          ))}
      </Menu.Section>
    </Menu.Panel>
  );
}
